export const schema = {
  properties: {
    description: {
      type: "string",
      default: ""
    },

    serviceOwner: {
      type: "string",
      default: ""
    },

    businessUnit: {
      type: "string",
      default: ""
    },

    servingURL: {
      type: "string",
      default: "",
      format: "url"
    },

    location: {
      type: "string",
      default: ""
    },

    platform: {
      type: "string",
      default: ""
    },

    hipchatRoomName: {
      type: "string",
      default: ""
    },

    pagerdutyServiceID: {
      type: "string",
      default: ""
    },

    team: {
      type: "string",
      default: ""
    },

    serviceTier: {
      type: "integer",
      enum: [0, 1, 2, 3],
      default: 0
    }

    // compliancePolicyId: {
    //   type:    'string',
    //   default: ''
    // }
  }
};

// documentation, tags, admins
